import { EMPTY_LIST } from '../../../../../constants/common'
import {
  toEmailRecipientSelectItem,
  toEmailRecipientSelectItems,
} from '../../../../Email'
import {
  EMAIL_RECIPIENT_TYPE_APPLICANT,
  EMAIL_RECIPIENT_TYPE_PROVIDERS,
} from '../../RequestProfileTabEmailsAddButton'

export function getToRecipients({
  recipientType,
  requestContractors,
  requestData,
}) {
  if (recipientType === EMAIL_RECIPIENT_TYPE_APPLICANT && requestData?.owner) {
    return [toEmailRecipientSelectItem(requestData.owner)]
  }

  if (recipientType === EMAIL_RECIPIENT_TYPE_PROVIDERS) {
    return toEmailRecipientSelectItems(requestContractors)
  }

  return EMPTY_LIST
}
